import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { UtilService } from './services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'user-web';
  cityName: any;
  cityId: any;
  profile: any;
  name: any;
  loginFlag: any;
  headerFlag: any = true;
  footerFlag: any = true;
  previousUrl: string = '';
  constructor(
    private translate: TranslateService,
    private router: Router,
    private location: Location,
    private util: UtilService
  ) {
    const lng = localStorage.getItem('language');
    if (!lng || lng === null) {
      localStorage.setItem('language', 'en');
    }
    this.translate.use(localStorage.getItem('language'));
    if (localStorage.getItem('uid')) {
      this.loginFlag = true;
    } else {
      this.loginFlag = false;
    }
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event.url == '/login' || event.url == '/register') {
          this.headerFlag = false;
        } else {
          this.headerFlag = true;
        }
        if (event.url == '/home' || event.url == '/' || event.url.includes('rest-details')) {
          this.footerFlag = true;
        } else {
          this.footerFlag = false;
        }
      }
    });
  }
}
